import { render } from "./ContentCompliant.vue?vue&type=template&id=e1aa80fc"
import script from "./ContentCompliant.vue?vue&type=script&lang=js"
export * from "./ContentCompliant.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__